<script lang="ts">
  import type { IPanelData, IULink, IUPicture } from "../../../core/types";
  import UPicture from "../../../core/u-elements/UPicture.svelte";
  import ULink from "../../../core/u-elements/ULink.svelte";

  enum ImagePositionEnum {
    Left = "Left",
    Right = "Right",
  }

  interface ISingleSpot extends IPanelData {
    link: IULink;
    title: string;
    teaser: string;
    date: string;
    image?: IUPicture;
    imagePosition?: ImagePositionEnum;
  }

  export let data: ISingleSpot;
</script>

<section class="g-centered">
  <div
    class="single-spot"
    class:reverse={data.imagePosition === ImagePositionEnum.Right}
  >
    <div class="image">
      {#if data.image}
        <UPicture data={data.image} />
      {/if}
    </div>

    <div class="info">
      <div class="info__text">
        {#if data.date}
          <div class="date">{data.date}</div>
        {/if}

        <div class="title">{data.title || ""}</div>

        <div class="desc rte">
          {@html data.teaser}
        </div>
      </div>

      <ULink data={data.link} class="btn btn-spot" />
    </div>
  </div>
</section>

<style lang="scss">
  .single-spot {
    display: grid;
    margin-bottom: 50px;
    grid-auto-flow: row;
    column-gap: 40px;
    background: #ebebeb;

    @include md {
      grid-template-columns: 400px 1fr;
    }

    &.reverse {
      @include md {
        grid-template-columns: 1fr 400px;
        grid-auto-flow: dense;

        .info {
          grid-column-start: 1;
          margin-left: 20px;
        }

        .image {
          grid-column-start: 2;
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      padding: 25px 30px 25px 0;

      @include md-down {
        padding: 20px 15px 30px;
      }
    }
  }

  .date {
    @include small;
    margin-bottom: 8px;
  }

  .title {
    @include h2;
    margin-bottom: 10px;

    @include sm-down {
      margin-bottom: 8px;
    }
  }

  .desc {
    @include normal;
    margin-bottom: 10px;

    @include sm {
      margin-bottom: 20px;
    }
  }

  .image {
    :global(picture) {
      display: flex;
      height: 100%;
    }
    :global(img) {
      object-fit: cover;
    }
  }
</style>
